import { ChangeDetectionStrategy, Component, HostBinding, input, Input, OnInit } from '@angular/core';
import { TranslateService } from '@app/_modules/translate/translate.service';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { CarouselItem, SliderOptions } from './carousel.model';

@Component({
	selector: 'carousel',
	templateUrl: './carousel.template.html',
	styleUrls: ['./carousel.styles.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CarouselComponent implements OnInit {
	options = input<SliderOptions | undefined>({ imageWidth: 319, imageHeight: 297, textLines: 2, maxText: 130 });

	@Input() public data: CarouselItem[];
	@Input() public bodyHeightOverride?: string;
	config: SwiperOptions = {
		pagination: { el: '.swiper-pagination', clickable: true },
		navigation: {
			nextEl: '.slides__arrow--right',
			prevEl: '.slides__arrow--left',
		},
		a11y: {
			enabled: false,
		},
		breakpoints: {
			720: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
		slidesPerView: 1,
		slidesPerGroup: 1,
		rewind: true,
	};

	imageHeight = "297px";
	imageWidth = "319px";

	bodyHeight = "255px";
	titleHeight = "64px";
	textHeight = "127px";

	constructor(public translate: TranslateService) {}

	ngOnInit() {
		if (this.options()) {
			this.imageHeight = `${this.options().imageHeight}px`;
			this.imageWidth = `${this.options().imageWidth}px`;
			this.bodyHeight = `${552 - this.options().imageHeight}px`;
			this.textHeight = `${(552 - this.options().imageHeight) - this.options().textLines * 64}px`;
		}
		if (this.bodyHeightOverride) {
			this.bodyHeight = this.bodyHeightOverride;
		}
	}

	@HostBinding('class')
	get potentialOverflowClass() {
		return [
			this.data.length > 3 && 'swiper--over-three',
			this.data.length > 2 && 'swiper--over-two',
			this.data.length > 1 && 'swiper--over-one',
		].reduce((acc, curr) => {
			if (curr) {
        if (acc) {
          acc += ' ';
        }
				acc += curr;
			}
			return acc;
		}, '');
	}
}
